<template>
    <div class="test-summary-result">
        <test-result-circle class="test-summary-result-item" result="MTR_RES_FAILED"
                            :count="testResult.failures_number" hide-if-zero/>
    </div>
</template>
<script>
    import TestResultCircle from "./TestResultCircle"

    export default {
        name: 'test-summary-result',
        components: {TestResultCircle},
        props: {
            testResult: {}
        }
    }
</script>
<style lang="scss" scoped>
    .test-summary-result {
        &:hover, &:focus, &:active {
            background-color: $grey-lightest;
        }
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }

    .test-result-container-count {
        color: $grey-light;
        min-width: 2rem;
        font-size: 0.75rem;
        margin-right: 0.5rem;
    }

    .test-summary-result-item {
        margin: 0 0.3em;
    }
</style>